import React, { useRef, useState, useEffect, useContext } from "react";
import { MobileContext } from '../../contexts/MobileContext'
import { StyledCircleItem } from "../../styled-components/StyledCircleItem.style";
import { StyledMenuModal } from "../../styled-components/StyledMenuModal.style";
import { MyProfile } from "../MyProfile";
import { getNameInitials } from '../../utils/stringUtils'

const MenuModal = ({ name }) => {
    return (
        <StyledMenuModal >
            <MyProfile name={name}/>
        </StyledMenuModal>
    )
}


export const HeaderMenuAccount = ({ isMenuDesktopOpen, setIsMenuDesktopOpen }) => {
    const ref = useRef(null);
    const { name } = JSON.parse(localStorage.getItem('PROFILE_DATA_SISCOPE') ?? `{"name":"Hunter Souza"}"`);

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (ref.current && !ref.current.contains(event.target)) {
            if(!isMenuDesktopOpen) {
                setIsMenuDesktopOpen(false)
            }
          }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <div ref={ref} onClick={() => setIsMenuDesktopOpen(!isMenuDesktopOpen)}>
            <StyledCircleItem
                size="50px"
                borderColor="#2C3B82"
                backgroundColor="#2C3B82"
            >
                <h2 className="text-uppercase text-white info m-0">
                    {getNameInitials(name)}
                </h2>
                {isMenuDesktopOpen && <MenuModal name={name} />}
            </StyledCircleItem>
        </div>
    );
};
